import React from 'react';
import { Box } from '@mui/material';

const MetricTileGrid = ({ children, columnsLg = 5, minWidth = 220, gap = 2.5 }) => (
  <Box
    sx={{
      display: 'grid',
      width: '100%',
      gap,
      gridTemplateColumns: {
        xs: `repeat(auto-fit, minmax(${minWidth}px, 1fr))`,
        lg: `repeat(${columnsLg}, minmax(0, 1fr))`,
      },
    }}
  >
    {children}
  </Box>
);

export default MetricTileGrid;

